/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M4.5 0C3.2574 0 2.25 1.0074 2.25 2.25v19.5C2.25 22.9926 3.2574 24 4.5 24h15c1.2426 0 2.25-1.0074 2.25-2.25V2.25C21.75 1.0074 20.7426 0 19.5 0h-15Zm-.75 2.25a.75.75 0 0 1 .75-.75h6.75v21H4.5a.75.75 0 0 1-.75-.75V2.25Zm9 20.25h6.75a.75.75 0 0 0 .75-.75V2.25a.75.75 0 0 0-.75-.75h-6.75v21Z"
    clipRule="evenodd"
  />,
  'Split'
);
